import { NavLink } from 'react-router-dom';
import { NAV_ITEMS } from './navItems.js';

// P23J/P23K/P23L: densidade "estilo Claude" a partir de md — abaixo de md
// (mobile, sempre por toque) mantém min-h-control (40px). A partir de md,
// P23L cortou o bloco inteiro para ~65% da altura anterior (medido pelo
// usuário sobre um screenshot): padding vertical mínimo (py-0.5) e
// leading-none para a linha de texto não sobrar espaço além da altura do
// ícone. A variante horizontal só aparece na barra inferior mobile (sempre
// <768px), então não precisa de md:.
const navLinkClassName = ({ isActive }, { isHorizontal, collapsed }) =>
  `flex items-center gap-3 md:gap-2 rounded-lg text-sm md:text-[13px] md:leading-none transition-colors ${isHorizontal
    ? 'flex-1 flex-col justify-center gap-0.5 py-2 px-1 text-[11px] min-h-control'
    : `px-3 py-2 min-h-control md:min-h-0 md:py-1.5 ${collapsed ? 'justify-center' : ''}`
  } ${isActive ? 'text-primary bg-primary/10 font-medium' : 'text-on-surface/70 hover:text-on-surface hover:bg-primary/5'}`;

/**
 * Navegação global reutilizável (P23E): apenas destinos de produto, nunca
 * ações de conta (tema, configurações, sair — ver AccountMenu) ou controles
 * específicos do Chat (Novo Chat, histórico, persona — painel contextual à
 * parte). Recebe `items` explicitamente para que o App Shell renderize
 * grupos diferentes (Jornada / Acompanhamento) ou o subconjunto mobile sem
 * duplicar este componente. `NavLink` já aplica aria-current="page"
 * automaticamente no item ativo.
 */
export const MainNav = ({ items = NAV_ITEMS, orientation = 'vertical', collapsed = false, onNavigate }) => {
  const isHorizontal = orientation === 'horizontal';
  return (
    <nav
      aria-label="Navegação principal"
      className={isHorizontal ? 'flex items-stretch justify-between w-full' : 'flex flex-col space-y-0.5 md:space-y-0'}
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          onClick={onNavigate}
          className={(state) => navLinkClassName(state, { isHorizontal, collapsed })}
        >
          <span className="material-symbols-outlined text-[18px] md:text-[16px]" style={{ fontVariationSettings: "'FILL' 1" }}>
            {item.icon}
          </span>
          {(!collapsed || isHorizontal) && <span>{item.label}</span>}
        </NavLink>
      ))}
    </nav>
  );
};
